import { LANGUAGE_CODES, LANGUAGES } from "./constant";

export default {
  getLangCode: (lang) => {
    switch (lang) {
      case LANGUAGES.English:
        return LANGUAGE_CODES.English;
      case LANGUAGES.Turkish:
        return LANGUAGE_CODES.Turkish;
      case LANGUAGES.Arabic:
        return LANGUAGE_CODES.Arabic;
      case LANGUAGES.French:
        return LANGUAGE_CODES.French;
      case LANGUAGES.German:
        return LANGUAGE_CODES.German;
      case LANGUAGES.Russian:
        return LANGUAGE_CODES.Russian;
      case LANGUAGES.Spanish:
        return LANGUAGE_CODES.Spanish;
      case LANGUAGES.Italian:
        return LANGUAGE_CODES.Italian;
      case LANGUAGES.Croatian:
        return LANGUAGE_CODES.Croatian;

      default:
        return LANGUAGE_CODES.English;
    }
  },

  getTurkishCharaterFixedList: (str) => {
    if (!str) return "";
    str = str.replace(/İ/g, "i");
    str = str.replace(/I/g, "i");
    str = str.toLowerCase();
    str = str.replace(/ı/g, "i");
    str = str.replace(/ü/g, "u");
    str = str.replace(/ğ/g, "g");
    str = str.replace(/ç/g, "c");
    str = str.replace(/ş/g, "s");
    str = str.replace(/ö/g, "o");

    return str;
  },

  combine: (a, min) => {
    var fn = function (n, src, got, all) {
      if (n === 0) {
        if (got.length > 0) {
          all[all.length] = got;
        }
        return;
      }
      for (var j = 0; j < src.length; j++) {
        fn(n - 1, src.slice(j + 1), got.concat([src[j]]), all);
      }
      return;
    };
    var all = [];
    for (var i = min; i < a.length; i++) {
      fn(i, a, [], all);
    }
    all.push(a);
    return all;
  },

  renderDate: (dateString) => {
    if (!dateString || dateString === "") return;
    let date = new Date(dateString);
    return date.toLocaleDateString(localStorage.getItem("i18nextLng"));
  },

  createGuid: () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  },
};
